import axios from 'axios';

import router from '@/router';
import store from '@/store';
import { get } from '@/helpers';

// import SetupAPI from '@/store/api/setup.js';

router.beforeEach((to, from, next) => {
  let timeout = setTimeout(() => {
    store.commit('loaded', false);

    // router.app.$Progress.set(0);
    // router.app.$Progress.start();
  }, 50);

  // if (to.meta.progress !== undefined) {
  //   let meta = to.meta.progress;
  //   // parse meta tags
  //   router.app.$Progress.parseMeta(meta);
  // }

  if (store.getters.error && store.getters.error.code !== 404) store.commit('setError', null);
  setTimeout(() => store.commit('updateSidebarVisibility', false), 150);

  document.title = to.meta.title ? to.meta.title : document.title;

  const cms = store.getters.CMS.id;
  const category = get(to.meta, 'category.key');
  const key = get(to.params, 'key');

  const skipMiddleware = get(to.meta, 'skipMiddleware', false);
  if (skipMiddleware) {
    clearTimeout(timeout);
    store.commit('loaded', true);
    // router.app.$Progress.finish();
    return next();
  }

  if (category && key && cms) {
    next();
    store
      .dispatch('fetchCategoryPost', { category, key, cms: parseInt(cms) })
      .then(data => {
        clearTimeout(timeout);
        // setTimeout(() => store.commit('setPage', data), 0) // wait for the page transition

        store.commit('setPage', data);
        store.commit('loaded', true);
        // router.app.$Progress.finish();
      })
      .catch(error => {
        store.commit('loaded', true);
        // router.app.$Progress.fail();
        if (error.networkError) {
          // error.graphQLErrors || // does not work well on logout
          store.commit('setError', { code: 500, message: 'Corrupt API Response!' });
        }
      });
  } else if (cms) {
    next();
    store
      .dispatch('fetchMenuItem', { path: to.path, cms: parseInt(cms) })
      .then(data => {
        clearTimeout(timeout);
        // setTimeout(() => store.commit('setPage', data), 0) // wait for the page transition

        store.commit('setPage', data.page);
        store.commit('loaded', true);
        // router.app.$Progress.finish();
      })
      .catch(error => {
        store.commit('loaded', true);
        // router.app.$Progress.fail();
        if (error.networkError) {
          // error.graphQLErrors || // does not work well on logout
          store.commit('setError', { code: 500, message: 'Corrupt API Response!' });
        }
      });
  } else {
    next();
  }
});

router.afterEach(async route => {
  const analyticsRoute = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_ANALYTICS_ROUTE}`;

  // async function reportPageView() {
  const reportPageView = route => {
    let pageID;
    if (route.meta?.pageID) pageID = parseInt(Number(route.meta?.pageID));

    let menuItemID;
    if (route.meta?.menuItemID) menuItemID = parseInt(Number(route.meta?.menuItemID));

    let categoryKey;
    let categoryPageKey;
    if (route.meta?.category?.key) {
      categoryKey = route.meta.category.key;
      categoryPageKey = route.params?.key;
    }

    const referrer = window.referrer || document.referrer;
    window.referrer = window.location.href;

    const data = {
      pageID,
      menuItemID,
      categoryKey,
      categoryPageKey,
      title: route.meta?.title,
      route: route.fullPath,
      screen: {
        width: screen.width,
        height: screen.height,
        depth: screen.colorDepth
      },
      window: {
        width: window.innerWidth,
        height: window.innerHeight
      }
    };

    return axios.post(analyticsRoute, data, {
      headers: {
        'X-Referer': referrer,
        Authorization: localStorage.getItem('member-token') ? `Bearer ${localStorage.getItem('member-token')}` : null
      }
    });
  };

  if (route.name) {
    if (route.redirectedFrom) {
      // report pageview for route.redirectedFrom
      const routes = router.getRoutes();
      let match = routes.find(el => route.redirectedFrom.split('?')[0].match(el.regex));
      match.fullPath = route.redirectedFrom;
      if (match) await reportPageView(match);
    }

    reportPageView(route);
  }

  // router.app.$Progress.finish();
});
